import createIcon from '../../createIcon';

/**
 * @component @name OutdoorGrill
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAyMkMxOC4xNiAyMiAxOS41IDIwLjY2IDE5LjUgMTlDMTkuNSAxNy4zNCAxOC4xNiAxNiAxNi41IDE2QzE1LjIgMTYgMTQuMSAxNi44NCAxMy42OCAxOEg4LjY0TDEwLjYzIDE0Ljk0QzEwLjkyIDE0Ljk4IDExLjIxIDE1IDExLjUgMTVDMTEuNzkgMTUgMTIuMDggMTQuOTggMTIuMzcgMTQuOTRMMTMuMzkgMTYuNTFDMTMuODEgMTUuOTggMTQuMzUgMTUuNTYgMTQuOTkgMTUuM0wxNC4zOSAxNC4zN0MxNi44MSAxMy4yNyAxOC41IDEwLjg0IDE4LjUgOEg0LjVDNC41IDEwLjg0IDYuMTkgMTMuMjcgOC42MiAxNC4zN0w0LjY3IDIwLjQ1QzQuMzcgMjAuOTEgNC41IDIxLjUzIDQuOTYgMjEuODNDNS40MiAyMi4xMyA2LjA0IDIyIDYuMzQgMjEuNTRMNy4zNCAxOS45OUgxMy42OEMxNC4xIDIxLjE2IDE1LjIgMjIgMTYuNSAyMlpNMTYuNSAxOEMxNy4wNSAxOCAxNy41IDE4LjQ1IDE3LjUgMTlDMTcuNSAxOS41NSAxNy4wNSAyMCAxNi41IDIwQzE1Ljk1IDIwIDE1LjUgMTkuNTUgMTUuNSAxOUMxNS41IDE4LjQ1IDE1Ljk1IDE4IDE2LjUgMThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC45MSA3SDkuOTFDMTAuMDYgNS44NSAxMC4xNCA1LjM2IDkuMDIgNC4wNEM4LjYgMy41NCA4LjM0IDMuMjcgOC41NiAySDcuNTdDNy4zNiAzLjExIDcuNiA0LjA1IDguNDYgNC45NkM4LjY4IDUuMiA5LjI1IDUuNjMgOC45MSA3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjM5IDdIMTIuMzlDMTIuNTQgNS44NSAxMi42MiA1LjM2IDExLjUgNC4wNEMxMS4wOCAzLjU0IDEwLjgyIDMuMjYgMTEuMDQgMkgxMC4wNUM5Ljg0IDMuMTEgMTAuMDggNC4wNSAxMC45NCA0Ljk2QzExLjE3IDUuMiAxMS43NCA1LjYzIDExLjM5IDdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuOTEgN0gxNC45MUMxNS4wNiA1Ljg1IDE1LjE0IDUuMzYgMTQuMDIgNC4wNEMxMy42IDMuNTQgMTMuMzQgMy4yNyAxMy41NiAySDEyLjU3QzEyLjM2IDMuMTEgMTIuNiA0LjA1IDEzLjQ2IDQuOTZDMTMuNjggNS4yIDE0LjI1IDUuNjMgMTMuOTEgN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OutdoorGrill = createIcon('OutdoorGrill', [
  [
    'path',
    {
      d: 'M16.5 22C18.16 22 19.5 20.66 19.5 19C19.5 17.34 18.16 16 16.5 16C15.2 16 14.1 16.84 13.68 18H8.64L10.63 14.94C10.92 14.98 11.21 15 11.5 15C11.79 15 12.08 14.98 12.37 14.94L13.39 16.51C13.81 15.98 14.35 15.56 14.99 15.3L14.39 14.37C16.81 13.27 18.5 10.84 18.5 8H4.5C4.5 10.84 6.19 13.27 8.62 14.37L4.67 20.45C4.37 20.91 4.5 21.53 4.96 21.83C5.42 22.13 6.04 22 6.34 21.54L7.34 19.99H13.68C14.1 21.16 15.2 22 16.5 22ZM16.5 18C17.05 18 17.5 18.45 17.5 19C17.5 19.55 17.05 20 16.5 20C15.95 20 15.5 19.55 15.5 19C15.5 18.45 15.95 18 16.5 18Z',
      key: '1cwmwb',
    },
  ],
  [
    'path',
    {
      d: 'M8.91 7H9.91C10.06 5.85 10.14 5.36 9.02 4.04C8.6 3.54 8.34 3.27 8.56 2H7.57C7.36 3.11 7.6 4.05 8.46 4.96C8.68 5.2 9.25 5.63 8.91 7Z',
      key: '19rhvy',
    },
  ],
  [
    'path',
    {
      d: 'M11.39 7H12.39C12.54 5.85 12.62 5.36 11.5 4.04C11.08 3.54 10.82 3.26 11.04 2H10.05C9.84 3.11 10.08 4.05 10.94 4.96C11.17 5.2 11.74 5.63 11.39 7Z',
      key: 'x5yxn7',
    },
  ],
  [
    'path',
    {
      d: 'M13.91 7H14.91C15.06 5.85 15.14 5.36 14.02 4.04C13.6 3.54 13.34 3.27 13.56 2H12.57C12.36 3.11 12.6 4.05 13.46 4.96C13.68 5.2 14.25 5.63 13.91 7Z',
      key: '17zsby',
    },
  ],
]);

export default OutdoorGrill;
